import { FunctionComponent, Fragment } from 'react';
import { useTheme } from '@mui/material/styles';
import { ComposedChart, Area, XAxis, YAxis, Label, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function createData(time: string, Store674: number, Store435: number ) {
  return { time, 'Store 674': Store674, 'Store 435': Store435 };
}

const data = [
  createData('Jun', 700, 500),
  createData('Jul', 550, 1200),
  createData('Aug', 750, 1000),
  createData('Sept', 350, 800),
  createData('Oct', 800, 900),
];

type CircleLegendProps = {
  label: string,
  color: string,
}

const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color }) => {
  return (
      <Stack direction="row" sx={{ justifyContent: 'start' }} spacing={1}>
              <Box sx={{
                  borderRadius: '50%',
                  height: 18,
                  width: 22,
                  backgroundColor: color,
              }} />
              <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
              }}>
              <Typography sx={{
                  padding: '0px 10px 10px 5px',
                  color: 'primary.main'
              }}>
                  {label}
              </Typography>
              </Box>
      </Stack>
  )
}


export default function PeopleEnrolledChart() {
  const theme = useTheme();
  const renderLegend = (props: any) => {
    const { payload } = props;

    return (
        <Stack direction="row" sx={{ mt: '5px', ml: 27, mb: 4 }}>
            {
                payload.map((entry: any, i:number) => {
                    return (
                            <CircleLegend key={entry.dataKey} label={entry.dataKey} color={entry.color} />
                    )
                })
            }
        </Stack>
    )
}

  return (
    
    <Fragment>
      <ResponsiveContainer >

        <ComposedChart 
        data={data}
        height={300}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 0,
          }}>
          <defs>
            <linearGradient id="color1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="10%" stopColor={theme.palette.text.secondary} stopOpacity={0.3} />
              <stop offset="90%" stopColor="white" stopOpacity={0.1} />
            </linearGradient>

            <linearGradient id="color2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="10%" stopColor={theme.palette.text.secondary} stopOpacity={0.2} />
              <stop offset="90%" stopColor="white" stopOpacity={0.1} />
            </linearGradient>


          </defs>

          <Legend verticalAlign="top" content={renderLegend} />
          <XAxis
            dataKey="time"
            tickLine={false}
            strokeDasharray="3 3"
            tickMargin={10}
          />
          <YAxis
            stroke='gray'
            tickLine={false}
            axisLine={false}
            height={322}
          >
            <Label
              angle={270}
              position="left"
              style={{
                textAnchor: 'middle',
                fill: 'transparent',
              }} />
          </YAxis>
          <CartesianGrid stroke={theme.palette.shadow.dark} strokeDasharray="3 3" vertical={false} />

          <Area type="monotone" dataKey="Store 674" strokeWidth={3}
             height={322}
            fillOpacity={1} fill="url(#color1)" />

          <Area type="monotone" dataKey="Store 435" strokeWidth={3} stroke={theme.palette.info.light}
             height={322}
            fillOpacity={1} fill="url(#color2)" />


        </ComposedChart>
      </ResponsiveContainer>
    </Fragment>
  );
}